import { type } from "@testing-library/user-event/dist/type";

export const emptyData = (data)=>({
	kg_id: data.kg_id,
    name: '',
    periodStartYear: '',
    number: '',
    type: '',
    specifics: '',
    specialization: 'без спеціалізації',
    language: 'Українська',
    educators: '',
    nutrition: '',
    address: data.contacts.address.string,
	price:[],
    internationalAgreement: false,
    workMode: 'Повний день',
    workStart: '07:00',
    workEnd: '19:00',
    capacity: {
      fullDay: { actual: 0, planned: 0 },
      shortStay: { actual: 0, planned: 0 },
      inclusiveFullDay: { actual: 0, planned: 0 },
      inclusiveShortStay: { actual: 0, planned: 0 }
    },
	district: data.contacts.address.district,
	phones: data.contacts.phones,
	site: data.contacts.site || 'none',
	email:data.contacts.email
  });




  export const transformToServer = (data, type)=>{


    function quickFloat(str) {
      const num = parseFloat(String(str).replace(',', '.'));
      return isNaN(num) ? 0 : Math.round(num * 100) / 100;
    }


	const indexGroup = dictionary_default.typeGroupAges.findIndex(r=>r.type == data.type);

	const typeGroupsName = dictionary_default.typeGroups[indexGroup];

  
  data.price = data.price.map(p=>{ if(p._id.length != 24) delete p._id; p.averageForDay = quickFloat(p.averageForDay); return p;});
  
		

	return ({
    "name": data.name,
    "number": data.number,
    "type": typeGroupsName,
    "typeNumber": data.type,
    "specialization": data.specialization || 'без спеціалізації',
    "specifics": data.specifics,
    "nutrition": data.nutrition,
    "ageLimit": {
        "from": dictionary_default.typeGroupAges[indexGroup].from,
        "to": dictionary_default.typeGroupAges[indexGroup].to
    },
    "contacts": {
        "address": {
            "string": data.address,
            "district": data.district
        },
        "phones": data.phones
        ,
        "site": data.site,
        "email": data.email
    },
    "placesAmount": {
        "sleepingPlaces": +data.capacity.fullDay.actual,
        "withoutBeds": +data.capacity.shortStay.actual,
        "inclusive": +data.capacity.inclusiveFullDay.actual,
        "inclusiveShort": +data.capacity.inclusiveShortStay.actual,
        "norm": 0
    },
    "planedAmount": {
        "sleepingPlaces": +data.capacity.fullDay.planned,
        "withoutBeds": +data.capacity.shortStay.planned,
        "inclusive": +data.capacity.inclusiveFullDay.planned,
        "inclusiveShort": +data.capacity.inclusiveShortStay.planned
    },
    "inclusiveSpecialization": data.specialization,
    "price": data.price,
    "workingHours": {
        "type": data.workMode,
        "timeFrom": data.workStart,
        "timeTo": data.workEnd
    },
    "educators": [
        {
            "firstName": data.educators
        }
    ],
    "internationalAgreement": data.internationalAgreement,
    "periodStartYear": data.periodStartYear
  })}

  export const transformFromServer = (serverData) => {
  if (!serverData) {
    console.warn('transformFromServer: serverData is null or undefined');
    return getEmptyFormData();
  }

  try {
    // Находим индекс группы по type из серверных данных
    const indexGroup = dictionary_default.typeGroups.findIndex(
      groupName => groupName === serverData.type
    );


    return {
      name: serverData.name || '',
      number: serverData.number || '',
      type: serverData.typeNumber ?? indexGroup,
      specialization: serverData.specialization || 'без спеціалізації',
      specifics: serverData.specifics || '',
      nutrition: serverData.nutrition || '',
      
      address: serverData.contacts?.address?.string || '',
      district: serverData.contacts?.address?.district || '',
      
      phones: serverData.contacts?.phones || '',
      site: serverData.contacts?.site || '',
      email: serverData.contacts?.email || '',
      
      capacity: {
        fullDay: {
          actual: serverData.placesAmount?.sleepingPlaces ?? 0,
          planned: serverData.planedAmount?.sleepingPlaces ?? 0
        },
        shortStay: {
          actual: serverData.placesAmount?.withoutBeds ?? 0,
          planned: serverData.planedAmount?.withoutBeds ?? 0
        },
        inclusiveFullDay: {
          actual: serverData.placesAmount?.inclusive ?? 0,
          planned: serverData.planedAmount?.inclusive ?? 0
        },
        inclusiveShortStay: {
          actual: serverData.placesAmount?.inclusiveShort ?? 0,
          planned: serverData.planedAmount?.inclusiveShort ?? 0
        }
      },
      
      price: serverData.price ?? 0,
      
      workMode: serverData.workingHours?.type || '',
      workStart: serverData.workingHours?.timeFrom || '',
      workEnd: serverData.workingHours?.timeTo || '',
      
      educators: serverData.educators?.[0] && serverData.educators.map(e=>e.firstName).join(", ") || '',
      
      internationalAgreement: serverData.internationalAgreement || false,
      period: serverData.periodStartYear || '',
      planedAmountHistory: serverData.planedAmountHistory
    };
  } catch (error) {
    console.error('Error in transformFromServer:', error);
    return getEmptyFormData();
  }
};

// Функция для пустых данных формы
const getEmptyFormData = () => ({
  name: '',
  number: '',
  type: 0,
  specialization: 'без спеціалізації',
  specifics: '',
  nutrition: '',
  address: '',
  district: '',
  phones: '',
  site: '',
  email: '',
  capacity: {
    fullDay: { actual: 0, planned: 0 },
    shortStay: { actual: 0, planned: 0 },
    inclusiveFullDay: { actual: 0, planned: 0 },
    inclusiveShortStay: { actual: 0, planned: 0 }
  },
  price: 0,
  workMode: '',
  workStart: '',
  workEnd: '',
  educators: '',
  internationalAgreement: false,
  periodStartYear: ''
});





const curDate = new Date();

const curPeriod = curDate.getMonth() > 7 ? curDate.getFullYear(): curDate.getFullYear() - 1;

const nextPeriod = curPeriod + 1;

const periods =  8 > curDate.getMonth() > 1 ? [curPeriod, nextPeriod] : [curPeriod]; 

 
export const dictionary_default = {

	periods_start_year: periods,
	typeGroups: [
		'друга група раннього віку — від 1-го до 2-х років',
		'перша молодша група — від 2-х до 3-х років',
		'друга молодша група — від 3-х до 4-х років',
		'середня група — від 4-х до 5-ти років',
		'старша група — від 5-ти до6(7) років',
		'підготовча до школи група — від 6-ти до 7-ми років',
		'різновікова – від 3-х до 5-ти років',
		'різновікова – від 3-х до 6-ти років',
		'різновікова – від 4-х до 6-ти років',
		'від 1 року і 6 місяців до 3 років',
		'окрема тимчасова нефункціональна різновікова',
		'різновікова – від 1-го до 3-х років',
		'від 6 місяців до 1-го року'
    ],
  typeGroupAges: [
      { from: 1, to: 2, type: 2 }, { from: 2, to: 3, type: 3 }, { from: 3, to: 4, type: 4 }, { from: 4, to: 5,  type: 5  }, { from: 5, to: 6,  type: 6 },
      { from: 6, to: 7,  type: 7 }, { from: 3, to: 5,  type: 10 }, { from: 3, to: 6,  type: 11 }, { from: 4, to: 6,  type: 12 },
      { from: 1.6, to: 3, type: 14 }, {from: 0, to:0, type:15 }, {from: 1, to:3, type:16 }, {from: 0.6, to:1, type:17 }
  ],
  typeGroupAgesTransfer: [
      { from: 1, to: 2, type: 2 }, { from: 2, to: 3, type: 3 }, { from: 3, to: 4, type: 4 }, { from: 4, to: 5,  type: 5  }, { from: 5, to: 9,  type: 6 },
      { from: 6, to: 7,  type: 7 }, { from: 3, to: 5,  type: 10 }, { from: 3, to: 9,  type: 11 }, { from: 4, to: 9,  type: 12 },
      { from: 1.5, to: 3, type: 14 }, { from: 0, to: 10, type: 15 }, {from: 1, to:3, type:16 }, {from: 0.6, to:1, type:17 }
  ],
  specificsGroup: [
      'Загального розвитку', 'Комбінована', 'Сімейна', 'Санаторна', 'Спеціальна'
  ],
	typeKitchen:{
		standart: "Звичайне",
		diet: "Дієтичне"
	},
	ageCategoriesKitchen:['1_3', '2_3', '1_4', '4_6']

}

